import { createScript as t } from "./functions.js";
function o() {
  return [
    t("hs-script-loader", "//js-na1.hs-scripts.com/44661837.js", { defer: !0 })
  ].forEach((r) => {
    document.body.append(r);
  }), {};
}
export {
  o as addChat
};
